import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const titleVariants = cva('font-bold tracking-tight',
  {
    variants: {
      as: {
        h1: 'text-4xl md:text-5xl lg:text-6xl',
        h2: 'text-3xl md:text-4xl lg:text-5xl',
        h3: 'text-2xl md:text-3xl lg:text-4xl',
        h4: 'text-xl md:text-2xl lg:text-3xl',
        h5: 'text-lg md:text-xl lg:text-2xl',
        h6: 'text-base md:text-lg lg:text-xl',
      },
    },
    defaultVariants: {
      as: 'h2',
    },
  }
);

export interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof titleVariants> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const Title = React.forwardRef<HTMLHeadingElement, TitleProps>(
  ({ className, as = 'h2', ...props }, ref) => {
    return React.createElement(as, {
      className: cn(titleVariants({ as, className })),
      ref,
      ...props,
    });
  }
);

Title.displayName = 'Title';

export { Title, titleVariants };
